import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderWillDevotional from "../../../../src/content/willgrahameasterdevotional/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderWillDevotional,
  React
};